import React from "react";
import Footer from "../Footer";
import DashboardHead from "./DashboardHead";
import DashboardContent from "./DashboardContent";
import DashboardAbout from "./DashboardAbout";
import Webinar from "./Webinar";
import TitleBar from "../TitleBar";
import Navbar from "../Navbar";


const Dashboard = () => {

    return (
        <>
            <TitleBar title="Dashboard" />
            <Navbar />
            <section className="siteWrap">
                <DashboardHead />
                <DashboardContent />
                {/* <DashboardAbout /> */}
            </section>
            {/* <Webinar /> */}
            <Footer />
        </>
    )
}

export default Dashboard;